<template>
  <div>
    <v-select
      v-model="locale"
      :items="items"
      item-text="text"
      item-value="value"
      outlined
      dense
      style="width:80px; margin-top: 4px"
      class="mr-2"
    >
      <template v-slot:selection="{ item }">
        <img :src="item.flag" height="13px"/>
      </template>
      <template v-slot:item="{ item }">
        <img :src="item.flag" height="13px"/>
      </template>
    </v-select>
  </div>
</template>

<script>
import vuei18n from '@/i18n'

export default {
  data: () => ({
    locale: null,
    items: [
      { value: 'fr', flag: require('@/assets/app/images/flag_fr.png') },
      { value: 'en', flag: require('@/assets/app/images/flag_en.png') },
    ],
  }),
  computed: {
    vuei18nLocale() {
      return vuei18n.locale
    }
  },
  watch: {
    locale: {
      handler(val, oldVal) {
        vuei18n.locale = this.locale
        if (val && oldVal) {
          const query = { ...this.$route.query }
          if (this.locale !== 'fr') query.lang = this.locale 
          if (this.locale === 'fr') delete query.lang
          
          return this.$router.replace({ path: this.$route.path, query })
        }
      }
    },
    vuei18nLocale: {
      handler(val) {
        this.locale = val || 'fr'
      }
    }
  }
}
</script>

<style scoped>
  .v-input__slot > fieldset {
    border-width: 0 !important
  }

  .noBorder {
    border: none;
  }
</style>